<template>
  <div
    v-if="show"
    class="logistics"
  >
    <account-model
      title=""
      :hasFooter="false"
      @closeModel="closeModel"
    >
      <div
        class="logistics-header"
        slot="header"
      >
        <div class='tab-header'>
          <a
            v-for='(title,index) in titles'
            :key='index'
            @click='changeTab(index)'
            :class="bigTabIndex == index ? 'tab-class' : ''"
          >{{title}}</a>
        </div>
        <em
          class="el-icon-close"
          @click='closeModel($event)'
        ></em>
      </div>
      <div
        class="logistics-content"
        slot="content"
      >
        <account-nav
          v-model="tabIndex"
          :type="'tab'"
          :tabValue="logicticsTabs"
          :isLogistics="true"
          :slipper="true"
          :mainStyles="{'font-size':'14px','padding':'0','line-height': '30px'}"
          @tabClick="getTagInfo"
        >
        </account-nav>
        <div
          class="logistics-loading"
          v-show="!hasNoLogis"
        >
          <div v-if="expressData && expressData != -1 && expressData != -2">
            <div
              class="logi-left"
              :style="styleObj1"
            >
              <p class="logi-title">配送信息</p>
              <!-- 配送信息 -->
              <div class="logi-info">
                <p
                  v-if="expressData.promiseInfo.promise"
                  class="logi-promise"
                >{{expressData.promiseInfo.promise}}</p>
                <div v-show="expressData.sendAddress.logisticsName">
                  <p class="title">快递公司：</p>
                  <p class="text">{{expressData.sendAddress.logisticsName}}</p>
                </div>
                <div v-show="expressData.logisticsInfo.logisticsNo">
                  <p class="title">快递单号：</p>
                  <p class="text">{{expressData.logisticsInfo.logisticsNo}}</p>
                </div>
                <div>
                  <p class="title">配送地址：</p>
                  <p class="text">{{expressData.sendAddress.address}}</p>
                </div>
              </div>
              <!-- 课程与配套讲义 -->
              <p class="logi-title logi-title-class">课程与配套讲义</p>
              <template v-if='expressData.productInfos'>
                <div
                  class="course-textbook"
                  v-for="($item, index) in expressData.productInfos"
                  :key="index"
                >
                  <div class="course">
                    <p>
                      <span class="subject-name">{{$item.identityName}}</span>
                      <span class="course-name">{{$item.productName}}</span>
                    </p>
                  </div>
                  <div class="textbook">
                    <p class="book">
                      配套讲义<span>&nbsp;(共{{$item.sendData.length}}件)&nbsp;:</span>
                      <img
                        class="fr"
                        v-if='$item.showAll'
                        @click='showProductName(index)'
                        src="~common/assets/img/order/up.png"
                      />
                      <img
                        class="fr"
                        v-else
                        @click='showProductName(index)'
                        src="~common/assets/img/order/down.png"
                      />
                      <span
                        class="fr"
                        @click='showProductName(index)'
                      >余{{$item.sendData.length}}项</span>
                    </p>
                    <!-- 会有一种课程的配套讲义和多种课程的配套讲义问题 -->
                    <div
                      v-show="$item.showAll"
                      v-for="(item,index) in $item.sendData"
                      :key="index"
                    >
                      <span class="send-gold">物品{{index+1}}:</span>
                      <span>{{item.productName}}</span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div
              class="logi-timeline"
              :style="styleObj1"
            >
              <ul
                class="logi-timeline-content"
                v-if="otmsInfo && otmsInfo.length > 0"
              >
                <li
                  class="logi-timeline-item"
                  v-for="(trace, index) in otmsInfo"
                  :key="index"
                >
                  <em class="logi-timeline-icon"></em>
                  <!-- <span>{{trace.content}}</span> -->
                  <p>{{trace.time}}</p>
                  <span>{{trace.content}}</span>
                </li>
              </ul>
              <error
                v-else
                type="blank"
                warning="暂时没有物流信息"
              ></error>
            </div>
          </div>
          <!-- 请求错误提示 -->
          <error
            v-if="expressData == -2"
            :warning="warning"
          ></error>
        </div>
        <!-- 无订单编号提示-->
        <error
          :type="'blank'"
          v-show="hasNoLogis"
          :warning="'商品已进入库房准备打包出库，请耐心等待!'"
        ></error>
      </div>
    </account-model>
  </div>
</template>

<script>
import axios from '~common/assets/js/ocenter-axios.js'
import { Loading } from 'element-ui'
import accountModel from '@/components/sub/accountModel.vue'
import accountNav from '@/components/sub/accountNav.vue'
import error from '@/components/sub/error.vue'
export default {
  components: {
    accountModel,
    accountNav,
    error
  },
  data () {
    return {
      // showAll: false, // 配套讲义是否展示
      orderId: '', // 订单号
      show: false,
      hasNoLogis: false, // 暂无订单编号标识
      titles: ['已发货', '待发货'], // 标头
      logicticsTabs: [], // 枚举包裹
      expressData: -1, // 获取配送信息
      warning: '请求失败,请重试......',
      sendList: [], // 已发货包裹信息
      unSendList: [], // 待发货包裹信息
      bigTabIndex: 0, // 当前是已发货还是未发货
      tabIndex: 0, // 当前是第几个包裹
      otmsInfo: [], // 物流节点
      loadFlag: false,
      loadingInstance: null
    }
  },
  computed: {
    styleObj1 () {
      if (this.logicticsTabs.length > 1) {
        return { height: '393px' }
      } else {
        return { height: '434px' }
      }
    }
  },
  watch: {
    loadFlag () {
      if (!this.loadFlag && this.loadingInstance) {
        this.loadingInstance.close()
        this.loadingInstance = null
      }
    }
  },
  methods: {
    showThisDialog (orderId) {
      this.orderId = orderId
      if (!this.loadingInstance) {
        this.loading('.order-lists-loading')
      }
      this.getLogictics()
    },
    // 包裹tab切换
    getTagInfo (index) {
      if (typeof index === 'number') {
        this.tabIndex = index
      }
      var variableName = 'sendList'
      var showAllTab = true
      if (this.bigTabIndex == 0) {
        variableName = 'sendList'
        showAllTab = false
      } else {
        variableName = 'unSendList'
        showAllTab = true
      }
      // 判断是否有待发货或者已发货的包裹
      if (this[variableName].length > 0) {
        this.expressData = this[variableName][this.tabIndex]
        this.expressData.productInfos.map(item => {
          item.showAll = showAllTab
        })
      } else {
        this.expressData = -2
        this.warning = '暂无包裹信息'
      }
      this.otmsInfo = this[variableName][this.tabIndex] ? this[variableName][this.tabIndex].expressInfo || [] : {}
      this.logicticsTabs = []
      this[variableName].map((item, oneIndex) => {
        this.logicticsTabs.push('包裹' + (++oneIndex))
      })
    },
    // 获取物流信息
    getLogictics () {
      let url = 'https://ocenter.xueersi.com/MyOrderData/getOrderPackages'
      axios.post(url, {
        orderNum: this.orderId
      })
        .then((res) => {
          this.loadFlag = false
          this.show = true
          if (res.status == 1) {
            this.sendList = res.data.sendList
            this.unSendList = res.data.unSendList
            // 获取自动定位包裹的位置，是已发货还是待发货，是第几个包裹
            if (this.sendList.length > 0) {
              var findIndex = this.sendList.findIndex(item => item.isChecked == 1)
              if (findIndex == -1) {
                this.getUnSendList()
              } else {
                this.bigTabIndex = 0
                this.tabIndex = findIndex
              }
            } else {
              this.getUnSendList()
            }
            this.getTagInfo()
          } else {
            this.loadFlag = false
            this.warning = res.data
            this.expressData = -2
          }
        })
        .catch(() => {
          this.show = true
          this.expressData = -2
          this.loadFlag = false
          console.log('获取物流 error')
        })
    },
    // 获取待发货的默认tab
    getUnSendList () {
      if (this.unSendList.length > 0) {
        var unfindIndex = this.unSendList.findIndex(item => item.isChecked == 1)
        if (unfindIndex == -1) {
          this.bigTabIndex = 0
          this.tabIndex = 0
        } else {
          this.bigTabIndex = 1
          this.tabIndex = unfindIndex
        }
      } else {
        this.bigTabIndex = 0
        this.tabIndex = 0
      }
    },
    // 关闭物流弹窗
    closeModel () {
      this.$emit('closeLogisticsDialog')
      this.warning = '请求失败,请重试......'
      this.show = false
    },
    // 已发货/待发货tab切换
    changeTab (index) {
      this.bigTabIndex = index
      this.tabIndex = 0
      this.getTagInfo()
    },
    // 展开配套课程
    showProductName (index) {
      var showFlag = this.expressData.productInfos[index].showAll
      this.expressData.productInfos[index].showAll = !showFlag
      this.assignForIE()
      this.expressData.productInfos = Object.assign([], this.expressData.productInfos)
    },
    // Object.assign() 兼容 IE 浏览器
    assignForIE () {
      if (typeof Object.assign != 'function') {
        Object.assign = function (target) {
          'use strict'
          if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object')
          }

          target = Object(target)
          for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index]
            if (source != null) {
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
          }
          return target
        }
      }
    },
    loading (selector) {
      this.loadFlag = true
      if (this.loadFlag) {
        this.loadingInstance = Loading.service({
          target: document.querySelector(selector),
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          fullscreen: false,
          background: 'rgba(255, 255, 255, 0.8)',
          customClass: 'loading'
        })
      }
    }
  }
}
</script>
<style lang="less">
.logistics {
  .model-title {
    height: 54px !important;
    line-height: normal !important;
    background: rgba(245, 245, 245, 1) !important;
  }
  .account-model .account-model-wrapper {
    width: 860px !important;
    height: 508px;
    padding-bottom: 10px;
  }
  .model-content {
    height: 454px;
    padding: 20px 32px 0px 32px !important;
    overflow: hidden;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .error-wrapper {
    margin-top: 60px;
    margin-left: 32px;
    .middle {
      width: 120px;
      height: 120px;
      img {
        width: 100%;
        height: 100%;
      }
      p {
        margin-top: 5px !important;
      }
    }
  }
}
</style>
<style lang='less' scoped>
.logistics-header {
  overflow: hidden;
  .tab-header {
    width: 164px;
    height: 30px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 12px;
    border: 1px solid #f13232;
    border-radius: 2px;
    a {
      width: 50%;
      height: 100%;
      display: inline-block;
      float: left;
      color: #f13232;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }
    .tab-class {
      background: #f13232;
      color: #fff;
    }
  }
}
.logistics-loading {
  min-height: 260px;
  .logi-left {
    width: 50%;
    float: left;
    border-right: 1px solid #dcdcdc;
    overflow-y: scroll;
    padding-right: 38px;
    .logi-title {
      font-size: 14px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-top: 10px;
    }
    .logi-title-class {
      margin: 20px 0px 12px 0px;
    }
  }
}
.logistics-content {
  .logi-info {
    font-size: 12px;
    margin: 7px 0 5px 0;
    & > div {
      height: 18px;
      margin-bottom: 5px;
    }
    .title {
      float: left;
    }
    .text {
      margin-left: 60px;
    }
    .logi-promise {
      font-size: 12px;
      color: #fe9b43;
      margin-bottom: 5px;
    }
  }
  .course-textbook {
    margin-bottom: 12px;
    padding: 14px 22px 20px 17px;
    background: rgba(245, 245, 245, 0.8);
    border-radius: 2px;
    border: 1px solid rgba(229, 229, 229, 1);
    font-family: PingFangSC-Regular;
    font-weight: 400;
    box-sizing: border-box;
    .course {
      .subject-name {
        background-color: transparent;
        color: #f13232;
        display: inline-block;
        min-width: 10px;
        line-height: 1;
        white-space: nowrap;
        text-align: center;
        border: 1px solid #f13232;
        vertical-align: middle;
        font-size: 12px;
        padding: 0.15rem;
        border-radius: 2px;
        margin-right: 2px;
      }
      .course-name {
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
      }
    }
    .textbook {
      margin-top: 10px;
      font-size: 12px;
      color: rgba(102, 102, 102, 1);
      line-height: 22px;
      .book {
        font-size: 12px;
        color: #333333;
        margin-bottom: 7px;
        .fr {
          float: right;
          color: #999999;
          vertical-align: middle;
          cursor: pointer;
        }
        img {
          cursor: pointer;
          margin-top: 2px;
        }
      }
      .send-gold {
        display: inline-block;
        width: 41px;
        margin-right: 7px;
        color: #999999;
      }
    }
    .show-more {
      cursor: pointer;
    }
  }
}
.logi-timeline {
  font-size: 12px;
  overflow: hidden;
  position: relative;
  color: #6e6e6e;
  background-color: #fff;
  z-index: 1;
  // margin-bottom: 15px;
  overflow-y: auto;
  .logi-timeline-content {
    margin-left: 23px;
    border-left: 1px solid #dcdcdc;
    .logi-timeline-item {
      position: relative;
      padding: 10px 0;
      margin-left: 20px;
      position: relative;
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        z-index: 0;
      }
      &:first-child {
        margin-top: 16px;
        padding-top: 0;
        color: #333333;
        font-weight: bolder;
        p {
          line-height: 14px;
          height: 14px;
        }
        &:before {
          content: "";
          width: 16px;
          height: 16px;
          position: absolute;
          top: 0;
          left: -28px;
          background-color: #fbbfbf;
          border-radius: 99px;
          z-index: 0;
        }
        & > .logi-timeline-icon {
          width: 10px;
          height: 10px;
          top: 3px;
          background-color: #f23030;
          border: none;
        }
      }
      &:last-child {
        &:after {
          content: "";
          width: 4px;
          height: 131%;
          position: absolute;
          top: 26px;
          left: -22px;
          background-color: #ffffff;
          z-index: 0;
        }
      }
      & > p {
        height: 20px;
        line-height: 20px;
      }
      .logi-timeline-icon {
        width: 12px;
        height: 12px;
        content: "";
        position: absolute;
        z-index: 1;
        left: -20px;
        display: block;
        top: 14px;
        -webkit-transform: translate(-50%);
        transform: translate(-50%);
        border: solid 3px #ffffff;
        border-radius: 99px;
        background-color: #e4e5e9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/dialog/logisticsDialog.vue